import { render, staticRenderFns } from "./DialogDrawer.vue?vue&type=template&id=4d38775e&scoped=true&lang=pug&"
import script from "./DialogDrawer.vue?vue&type=script&lang=ts&"
export * from "./DialogDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./DialogDrawer.vue?vue&type=style&index=0&id=4d38775e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38775e",
  null
  
)

/* custom blocks */
import block0 from "./DialogDrawer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports